import { connect } from 'react-redux'

import { actionTypes } from '../../actions/actionTypes'
import {
  setRecipeCardRequestWithIssueReasons,
  cleanErrorForRecipeCards,
} from '../../actions/recipeCards'
import { getSelectedRecipeCardsDetails } from '../../selectors/recipesSelectors'
import { RecipeCardIssues } from './RecipeCardIssues'

const mapStateToProps = (state) => ({
  didRequestError: Boolean(
    state.error.get(actionTypes.GET_HELP_SET_SELECTED_RECIPE_CARDS_ISSUES, null),
  ),
  isRequestPending: Boolean(
    state.pending.get(actionTypes.GET_HELP_SET_SELECTED_RECIPE_CARDS_ISSUES),
    false,
  ),
  selectedRecipeCardsDetails: getSelectedRecipeCardsDetails(state),
})

const RecipeCardIssuesContainer = connect(mapStateToProps, {
  setRecipeCardRequestWithIssueReasons,
  cleanErrorForRecipeCards,
})(RecipeCardIssues)

export { RecipeCardIssuesContainer }
